// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"327":"ec1ce8d3","801":"8f36f878"}[chunkId] || chunkId) + "." + {"327":"b0c08c849b0b00cd","408":"a418809ac64f9533","801":"c8b6e0bb92482e15","958":"afb4d719d2fe8348"}[chunkId] + ".js";
};